export default {
	namespaced: true,

	state: {
		dummy: {
			title: 'Dummy Recruitment',
			subTitle: 'Dummy Recruitment Sub Title',
			text: 'Dummy Recruitment Text',

			order: 10,

			schedules: {
				dummySchedule1: {
					title: 'Schedule',
					subTitle: 'Dummy Schedule 1',
					text: 'Dummy Schedule 1 Text',

					order: 10,

					startDate: {
						seconds: 1575223261
					},
					endDate: {
						seconds: 1575568861
					},

					steps: {
						dummySchedule1Step1: {
							stepTitle: 'Step 1',
							title: 'Schedule 1 - Step 1',
							subTitle: 'Step 1 Sub Title',
							text: 'Step 1 Text',
	
							order: 10,

							openStep: {
								title: 'Open Step',
								link: {
									to: {
										name: 'page',
										params: {
											pageName: 'recruitDummyStep',
											pageType: 'inputRecruit',

											recruitmentId: 'dummy',
											scheduleId: 'dummySchedule1',
											stepId: 'dummySchedule1Step1'
										}
									}
								}
							}
						},
						dummySchedule1Step2: {
							stepTitle: 'Step 2',
							title: 'Schedule 1 - Step 2',
							subTitle: 'Step 2 Sub Title',
							text: 'Step 2 Text',
	
							order: 20,

							openStep: {
								title: 'Open Step',
								link: {
									to: {
										name: 'page',
										params: {
											pageName: 'recruitDummyStep',
											pageType: 'inputRecruit',

											recruitmentId: 'dummy',
											scheduleId: 'dummySchedule1',
											stepId: 'dummySchedule1Step2'
										}
									}
								}
							}
						},
						dummySchedule1Step3: {
							stepTitle: 'Step 3',
							title: 'Schedule 1 - Step 3',
							subTitle: 'Step 3 Sub Title',
							text: 'Step 3 Text',
	
							order: 30,

							openStep: {
								title: 'Open Step',
								link: {
									to: {
										name: 'page',
										params: {
											pageName: 'recruitDummyStep',
											pageType: 'inputRecruit',

											recruitmentId: 'dummy',
											scheduleId: 'dummySchedule1',
											stepId: 'dummySchedule1Step3'
										}
									}
								}
							}
						}
					}
				},
				dummySchedule2: {
					subTitle: 'Dummy Schedule 2',
					text: 'Dummy Schedule 2 Text',

					order: 20,

					startDate: {
						seconds: 1576432861
					},
					endDate: {
						seconds: 1576605661
					},

					steps: {
						dummySchedule2Step1: {
							stepTitle: 'Step 1',
							title: 'Schedule 2 - Step 1',
							subTitle: 'Step 1 Sub Title',
							text: 'Step 1 Text',
	
							order: 10,

							openStep: {
								title: 'Open Step',
								link: {
									to: {
										name: 'page',
										params: {
											pageName: 'recruitDummyStep',
											pageType: 'inputRecruit',

											recruitmentId: 'dummy',
											scheduleId: 'dummySchedule2',
											stepId: 'dummySchedule2Step1'
										}
									}
								}
							}
						},
						dummySchedule2Step2: {
							stepTitle: 'Step 2',
							title: 'Schedule 2 - Step 2',
							subTitle: 'Step 2 Sub Title',
							text: 'Step 2 Text',
	
							order: 20,

							openStep: {
								title: 'Open Step',
								link: {
									to: {
										name: 'page',
										params: {
											pageName: 'recruitDummyStep',
											pageType: 'inputRecruit',

											recruitmentId: 'dummy',
											scheduleId: 'dummySchedule2',
											stepId: 'dummySchedule2Step2'
										}
									}
								}
							}
						},
						dummySchedule2Step3: {
							stepTitle: 'Step 3',
							title: 'Schedule 2 - Step 3',
							subTitle: 'Step 3 Sub Title',
							text: 'Step 3 Text',
	
							order: 30,

							openStep: {
								title: 'Open Step',
								link: {
									to: {
										name: 'page',
										params: {
											pageName: 'recruitDummyStep',
											pageType: 'inputRecruit',

											recruitmentId: 'dummy',
											scheduleId: 'dummySchedule2',
											stepId: 'dummySchedule2Step3'
										}
									}
								}
							}
						}
					}
				},
				dummySchedule3: {
					subTitle: 'Dummy Schedule 3',
					text: 'Dummy Schedule 3 Text',

					order: 30,

					startDate: {
						seconds: 1577210461
					},
					endDate: {
						seconds: 1577642461
					},

					steps: {
						dummySchedule3Step1: {
							stepTitle: 'Step 1',
							title: 'Schedule 3 - Step 1',
							subTitle: 'Step 1 Sub Title',
							text: 'Step 1 Text',
	
							order: 10,

							openStep: {
								title: 'Open Step',
								link: {
									to: {
										name: 'page',
										params: {
											pageName: 'recruitDummyStep',
											pageType: 'inputRecruit',

											recruitmentId: 'dummy',
											scheduleId: 'dummySchedule3',
											stepId: 'dummySchedule3Step1'
										}
									}
								}
							}
						},
						dummySchedule3Step2: {
							stepTitle: 'Step 2',
							title: 'Schedule 3 - Step 2',
							subTitle: 'Step 2 Sub Title',
							text: 'Step 2 Text',
	
							order: 20,

							openStep: {
								title: 'Open Step',
								link: {
									to: {
										name: 'page',
										params: {
											pageName: 'recruitDummyStep',
											pageType: 'inputRecruit',

											recruitmentId: 'dummy',
											scheduleId: 'dummySchedule3',
											stepId: 'dummySchedule3Step2'
										}
									}
								}
							}
						},
						dummySchedule3Step3: {
							stepTitle: 'Step 3',
							title: 'Schedule 3 - Step 3',
							subTitle: 'Step 3 Sub Title',
							text: 'Step 3 Text',
	
							order: 30,

							openStep: {
								title: 'Open Step',
								link: {
									to: {
										name: 'page',
										params: {
											pageName: 'recruitDummyStep',
											pageType: 'inputRecruit',

											recruitmentId: 'dummy',
											scheduleId: 'dummySchedule3',
											stepId: 'dummySchedule3Step3'
										}
									}
								}
							}
						}
					}
				}
			}
		}
	},

	getters: {
		get: state => state
	},

	mutations: {
		setValue (state, [key, value]) {
			state[key] = value;
		},
		setSubValue (state, [key, subKey, value]) {
			state[key][subKey] = value;
		}
	},

	actions: {
	}
}
